import { getExploreName } from '../utils/platform';

export const devConfig = {
  sdkKey: 'aP4K1BzaDHNmy6Wf2SFEF5o32fb0leUunnaT',
  sdkSecret: 'KgZf3W00JD7u5uk5cbAZSDgdSbAWSm7vA9ia',
  webEndpoint: 'zoom.us', // zfg use www.zoomgov.com
  topic: 'auction',
  name: 'KF Auction',
  password: '123123',
  signature: '',
  sessionKey: '',
  userIdentity: '',
  // The user role. 1 to specify host or co-host. 0 to specify participant, Participants can join before the host. The session is started when the first user joins. Be sure to use a number type.
  role: 1
};
